import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Panel } from "@/components/admin/AdminUI";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/format";

export default function NotesPanel({ userId, initial }) {
  const [items, setItems] = useState(initial || []);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const add = async (e) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try { const r = await api(`/admin/users/${userId}/notes`, { body: { text: text.trim() } }); setItems((n) => [r.note, ...n]); setText(""); }
    catch (err) { setError(err.message); } finally { setBusy(false); }
  };
  return (
    <Panel className="p-6" data-testid="user-notes-panel">
      <h2 className="font-semibold">Notes</h2>
      <p className="cw-soft mt-1 text-sm">Internal only. Every admin role can read and add notes.</p>
      <form onSubmit={add} className="mt-4 space-y-3">
        <Label htmlFor="note-text" className="sr-only">New note</Label>
        <Textarea id="note-text" rows={3} maxLength={2000} value={text} onChange={(e) => setText(e.target.value)} placeholder="What happened, what you told them…" data-testid="user-note-input" />
        {error && <p className="cw-error text-sm" role="alert" data-testid="user-note-error">{error}</p>}
        <Button type="submit" disabled={!text.trim() || busy} data-testid="user-note-add-button">{busy ? "Adding…" : "Add note"}</Button>
      </form>
      {items.length ? (
        <ul className="mt-5 divide-y divide-border" data-testid="user-notes-list">
          {items.map((n) => (
            <li key={n.id} className="py-3" data-testid={`user-note-${n.id}`}>
              <p className="whitespace-pre-wrap text-sm">{n.text}</p>
              <p className="cw-muted mt-1 text-xs">{n.author}{n.author_role ? ` (${n.author_role})` : ""} · {formatDate(n.created_at)}</p>
            </li>
          ))}
        </ul>
      ) : <p className="cw-muted mt-5 text-sm" data-testid="user-notes-empty">No notes yet.</p>}
    </Panel>
  );
}
